<template>
    <div>
        <transition name="modal">
            <div class="modal" style="display: block">
                <div class="modal-dialog modal-lg" role="document">
                    <form @submit.prevent="onSubmit()">
                        <div class="modal-content">
                            <div class="modal-header  abtg__header-modal">

                                <h5 class="modal-title abtg__modal-title" id="exampleModalLabel2">{{$t('upload.title_modal')}}</h5>

                                <div class="tools">
                                    <div class="abtg__close-button"><a data-dismiss="modal"    @click="closeModal()" ><i class="fas fa-times"></i></a></div>

                                </div>


                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="onSubmit()" class="abtg__air20">
                                    <div class="modal-body">

                                        <div class="row">
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                <input class="mdl-textfield__input abtg__input " name="price"
                                                       type="text"

                                                       v-model="formData.description">
                                                <label class="mdl-textfield__label abtg-select">{{$t('upload.description_modal')}}</label>

                                            </div>
                                        </div>
                                        <div class="row"  > 
                                            <p  v-if="formData.fileName.length > 0 ">File attuale: <a :href="'/storage/' + formData.fileName"
                                                                target="_blank"><i
                                                    class="far fa-file-pdf"></i> download </a></p>
                                            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label txt-width">
                                                <input class="mdl-textfield__input abtg__input" ref="file" id="file"
                                                       name="file" type="file"
                                                       @change="onFileSelected">


                                            </div>
                                            <p class="text-danger small" v-if="myErrors != ''">
                                                {{myErrors}}</p>
                                        </div>

                                        <div class="row">
                                            <div class="col">
                                                <!-- EDIT MODE -->

                                                <button type="submit"
                                                        class="  margin-right-10 btn-success float-right abtg__btn-star">
                                                    SALVA
                                                </button>


                                                <button type="button"
                                                        @click="deleteFile()"
                                                        v-if="formData.fileName.length > 0 "
                                                        class="margin-right-10 btn-success float-left abtg__btn-star">
                                                    CANCELLA
                                                </button>

                                            </div>
                                        </div> <!-- // end row -->
                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">

                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </transition>
    </div>
</template>


<script>
    import Modal from '../../components/commons/modal';
    import {mixin} from '../../helpers/helper'
    import {Money} from 'v-money';
    import {createHelpers} from 'vuex-map-fields';


    const {mapFields} = createHelpers({
        getterType: 'upload/getField',
        mutationType: 'upload/updateField',
    });

    export default {
        mixins: [mixin],
        components: {Money, Modal},
        props: ['content'],
        data: function () {
            return {
                selectedFile: null,
                banana: '',

                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                }
            }
        },

        computed: {
            ...mapFields(['showModal', 'formData', 'myErrors']),
        },
        created: function () {

        }
        ,
        methods: {
            onSubmit: function () {
                this.$parent.onSubmitFile(this.file, this.formData.description, this.formData.id);
            },
            closeModal: function () {
                this.$parent.triggerModalUpload();
            },

            deleteFile: function()
            {
                this.$parent.deleteFile();
            },
            onFileSelected: function () {
                this.file = this.$refs.file.files[0];
            }
        }
    }
</script>